import React from 'react';
import AppContainer from '../app-container';
import LocalizedStrings from '../../localization/strings';
import DocumentTitle from 'react-document-title';
import Loading from '../../components/loading';

import * as resultActions from '../../actions/result';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';
import moment from 'moment';

class ResultsPageContainer extends AppContainer {
    componentWillMount() {
        this.props.actions.fetchResults().then(this.handlePageResult.bind(this));
    }

    groupItems() {
        let groupedResults = {};
        this.props.results.items.forEach((result) => {
            let array = [];
            const key = `${result.seasonId}-${result.season.order}`;
            if (groupedResults[key]) {
                array = groupedResults[key];
                array.push(result);
            } else {
                array = [result];
            }
            groupedResults[key] = array;
        });
        return groupedResults;
    }

    renderSeasonGroupedResults(items) {
        const stages = [];
        items.forEach((stage) => {
            if (stage.global_results_stage) {
                stages.push(stage);
            }
        });
        if (!stages.length) {
            return;
        }

        return <div className="global-results-box">
            <span className="bold mt-10 mr-10">{LocalizedStrings.globalResults}:</span>
            {stages.map((stage) => {
                return <Link to={`/stages/${stage.id}/results`}
                             className="btn btn-main-color inline first-uppercase mt-10" key={`stage-${stage.id}`}>
                    {stage.name}
                </Link>

            })}
        </div>

    }

    renderTableResults(items) {
        return (
            <table className="table responsive" key={`table-${new Date().getTime()}`}>
                <thead>
                <tr>
                    <th>
                        {LocalizedStrings.stage}
                    </th>
                    <th>
                        {LocalizedStrings.date}
                    </th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {items.filter((stage) => {
                    return !stage.global_results_stage
                }).map(stage => {
                    return (
                        <tr key={`stage-${stage.id}`}>
                            <td>{stage.name}</td>
                            <td>{moment(stage.stage_date).format('YYYY-MM-DD HH:mm')}</td>
                            <td className="actions">
                                <Link to={`/stages/${stage.id}/results`}
                                      className="btn btn-main-color inline first-uppercase">
                                    {LocalizedStrings.results}
                                </Link>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        )
    }

    renderResults() {
        const {results} = this.props;
        const groupedResults = this.groupItems();
        if (!results.items.length) {
            return (
                <div>{LocalizedStrings.noResults}</div>
            )
        }
        return Object.keys(groupedResults).sort().reverse().map((key) => {
            return <div key={key}>
                {groupedResults[key].length
                    ? <h4 className="season-result-title">{groupedResults[key][0].season.name}</h4>
                    : ''}
                {this.renderSeasonGroupedResults(groupedResults[key])}
                {this.renderTableResults(groupedResults[key])}
            </div>
        });

    }

    render() {
        const {results} = this.props;
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.results)}>

                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{LocalizedStrings.results}</span>
                        </h1>
                        <div className="">
                            {results.loading
                                ? <Loading/>
                                : this.renderResults()}
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}

export default connect(function (state) {
    return {results: state.results.results};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...resultActions
        }, dispatch)
    };
})(ResultsPageContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/results-page-container.js